(function () {
    var controllerId = 'corporate.views.departmentsReport.index';
    var app = angular.module('app');

    app.controller(controllerId, [
        '$scope', '$state', '$stateParams', '$uibModal', 'abp.services.app.report', 'abp.services.app.commonLookup', 'appSession', 'Hms.PatientTickets.PatientTicketType',
        'moment',
        function ($scope, $state, $stateParams, $modal, reportSvc, commonLookupSvc, appSession, enumPatientTicketType, moment) {
            function init() {
                initServiceTypes();

                // TODO: Replace currency code after enabling cross-country.
                getTenantCurrencyCode();

                vm.lookupClinicLocations(null, $stateParams.clinicLocation);
                lookupBenefitGroups();
                lookupSubsidiaries();
                lookupCTs();
                findEmployeeFields();
                vm.getDepartmentsReport();
            }

            var vm = this;
            vm.financialYears = _.range(appSession.tenant.currentFinancialYear, appSession.tenant.firstFinancialYear - 1, -1);
            vm.isSubsidiary = appSession.user.subsidiaryId;
            vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
            vm.hasSpecialistModule = abp.features.isEnabled('Specialist.Enabled');
            vm.hasPharmacyModule = abp.features.isEnabled('Pharmacy.Enabled');
            vm.hasInpatientModule = abp.features.isEnabled('HasInpatientModule');
            vm.applicationHasMemberBenefitUtilization = abp.setting.getBoolean('Hms.Feature.MemberBenefitUtilization');
            vm.hasInsuranceModule = abp.setting.getBoolean('Hms.Feature.InsuranceModule')
                && abp.features.isEnabled('HasInsurance');

            vm.exporting = 0;

            vm.enums = {
              patientTicketType: enumPatientTicketType
            };

            $scope.$on("$viewContentLoaded", function () {
                App.initAjax();
            });

            vm.benefitGroups = [];
            function lookupBenefitGroups() {
                commonLookupSvc.findBenefitGroups({
                    maxResultCount: 999
                }).success(function (data) {
                    vm.benefitGroups = data.items;
                });
            }

            vm.subsidiaries = [];

            function lookupSubsidiaries() {
                commonLookupSvc.getCorporateSubsidiaries({ getDeletedSubsidiariesOrDepartment: true }).success(function (data) {
                    vm.subsidiaries = data.items;
                });
            }

            vm.departments = [];
            var allDepartments = [];
            vm.getCorporateSubsidiaryDepartments = function () {
                if (!allDepartments.length) {
                    commonLookupSvc.getCorporateSubsidiaryDepartments({ getDeletedSubsidiariesOrDepartment: true }).success(function (data) {
                        allDepartments = data.items;
                    });
                }
            };

            vm.getDepartments = function (search) {
                var subsidiaryIds = vm.isSubsidiary
                    ? appSession.user.subsidiaryId
                    : vm.requestParams.subsidiaryIds;

                if (subsidiaryIds.length > 0) {
                    vm.departments = [];

                    // Change department filter list according to selected subsidiaries.

                    _.forEach(subsidiaryIds, function (id) {
                        var d = _.filter(allDepartments, { 'subsidiaryId': id });
                        vm.departments = _.concat(vm.departments, d);
                    });
                } else {
                    vm.departments = allDepartments;
                }

                if (search) {
                    // Filter items based on search parameters.
                    // Exclude already selected items from the search.

                    vm.departments = _.filter(vm.departments, function (d) { 
                        return _.includes(d.name.toLowerCase(), search.toLowerCase()) && !vm.requestParams.departmentIds.includes(d.id)
                    });

                    // Only return top 10 in the department list for display.

                    vm.departments = _.slice(vm.departments, 0, 10);
                } else {
                    vm.departments = [];
                }
            };

            vm.resetDepartments = function () {
                vm.requestParams.departmentIds = [];

                vm.departments = [];
            };

            vm.clinicLocations = [];
            vm.lookupClinicLocations = function (search, id) {
                if (search || id) {
                    commonLookupSvc.findPatientTicketClinicLocations({
                        clinic: vm.requestParams.clinic,
                        id: id,
                        filter: search,
                        maxResultCount: 5
                    }).success(function (data) {
                        vm.clinicLocations = data.items;
                    }).finally(function () {
                        if (!vm.clinicLocations.length)
                            vm.requestParams.clinicLocation = null;
                    });
                }
            };

            vm.employeeFields = [];
            function findEmployeeFields() {
                commonLookupSvc.findEmployeeFields().success(function (data) {
                    if (data.items) {
                        vm.employeeFields = data.items;
                    }
                });
            }

            vm.cts = [];
            function lookupCTs() {
                reportSvc.findCTs().success(function (data) {
                    vm.cts = data.items;
                });
            }

            vm.serviceTypes = [];
            function initServiceTypes() {
                reportSvc.getServiceTypes().success(function (data) {
                    vm.serviceTypes = data;
                });
            }

            vm.loading = 0;
            vm.requestParams = {
                ticketType: $stateParams.ticketType,
                transactionNumber: $stateParams.transactionNumber,
                employeeType: $stateParams.employeeType,
                benefitGroupIds: $stateParams.benefitGroupIds,
                subsidiaryIds: $stateParams.subsidiaryIds || [],
                departmentIds: $stateParams.departmentIds || [],
                clinicLocation: $stateParams.clinicLocation,
                clinicType: $stateParams.clinicType,
                financialYear: $stateParams.financialYear,
                startDate: $stateParams.startDate,
                endDate: $stateParams.endDate,
                serviceType: $stateParams.serviceType
            };
            vm.advancedFiltersAreShown = vm.requestParams.benefitGroupIds || vm.requestParams.clinicType || $stateParams.clinicLocation;

            vm.dateRangeOptions = _.map(vm.financialYears, function (d) {
                var opt = App.createDateRangePickerOptions();
                var minDate = moment([d, appSession.tenant.firstFinancialMonth - 1, 1]);
                var maxDate = moment.min(moment([d + 1, appSession.tenant.firstFinancialMonth - 1, 1]).subtract(1, 'days'), moment(opt.maxDate));
                opt.minDate = moment(minDate);
                opt.min = moment(minDate);
                opt.maxDate = moment(maxDate);
                opt.max = moment(maxDate);
                opt.financialYear = d;
                return opt;
            });

            vm.dateRangeModel = {};

            vm.fyChanged = function () {
                var opt = _.find(vm.dateRangeOptions, { 'financialYear': vm.requestParams.financialYear });
                if (opt) {
                    vm.dateRangeModel.startDate = moment(opt.minDate);
                    vm.dateRangeModel.endDate = moment(opt.maxDate);
                }
                registerStateParams();
            };

            vm.fyChanged();

            var reportTemplateName = '';
            var reportFields = [];
            vm.getDepartmentsReport = function () {
                registerStateParams();
                vm.loading++;
                reportSvc.getDepartmentsReport(getRequestInput()).success(function (data) {
                    vm.data = data;
                    reportTemplateName = data.reportTemplateName;
                    reportFields = data.reportFields;
                }).finally(function (e) {
                    vm.loading--;
                });
            };

            function getEmployeeFieldFilters() {
                var employeeFieldFilters = [];
                _.each(vm.employeeFields, function (f) {
                    if (f.filter) {
                        var filter = _.trim(f.filter);
                        if (filter) {
                            employeeFieldFilters.push({
                                name: filter,
                                value: f.value
                            });
                        }
                    }
                });
                return { employeeFields: employeeFieldFilters };
            }

            function getRequestInput(selectedFields) {
                var input = $.extend({}, vm.requestParams, getEmployeeFieldFilters(), { reportFields: selectedFields });
                if (vm.dateRangeModel.startDate)
                    input.startDate = vm.dateRangeModel.startDate.format('YYYY-MM-DD');
                if (vm.dateRangeModel.endDate)
                    input.endDate = vm.dateRangeModel.endDate.format('YYYY-MM-DD');
                return _.omitBy(input, _.isNil);
            }

            function registerStateParams() {
                var startDate = null;
                var endDate = null;
                if (vm.dateRangeModel.startDate)
                    startDate = vm.dateRangeModel.startDate.format('YYYY-MM-DD');
                if (vm.dateRangeModel.endDate)
                    endDate = vm.dateRangeModel.endDate.format('YYYY-MM-DD');

                $state.transitionTo($state.current, {
                    ticketType: vm.requestParams.ticketType,
                    transactionNumber: vm.requestParams.transactionNumber,
                    employeeType: vm.requestParams.employeeType,
                    benefitGroupIds: vm.requestParams.benefitGroupIds,
                    subsidiaryIds: vm.requestParams.subsidiaryIds,
                    departmentIds: vm.requestParams.departmentIds,
                    clinicLocation: vm.requestParams.clinicLocation,
                    clinicType: vm.requestParams.clinicType,
                    financialYear: vm.requestParams.financialYear,
                    startDate: startDate,
                    endDate: endDate,
                    serviceType: vm.requestParams.serviceType
                }, {
                    notify: false
                });
            }

            vm.exportToExcel = function (option) {
                option = option || getRequestInput();

                vm.exporting++;
                reportSvc.getDepartmentsReportToExcel(option).success(function (data) {
                    App.downloadTempFile(data);
                }).finally(function () {
                    vm.exporting--;
                });
            };

            vm.export = function (type) {
                $modal.open({
                    templateUrl: require('/App/common/views/common/selectionModal.html'),
                    controller: "common.views.common.selectionModal as vm",
                    backdrop: "static",
                    resolve: {
                        templateName: function () {
                            return reportTemplateName;
                        },
                        fields: function () {
                            return reportFields;
                        },
                        modalTitle: function () {
                            return App.localize('SelectReportFields');
                        }
                    }
                }).result.then(function (selectedFields) {
                    var option = getRequestInput(selectedFields);

                    if (type === 0)
                        window.open(App.formatUrl('Print/DepartmentsReport?', option));
                    else
                        vm.exportToExcel(option);
                });
            };

            function getTenantCurrencyCode() {
                vm.loading++;
                commonLookupSvc.getTenantCurrencyCode()
                    .success(function (data) {
                        vm.currencyCode = data;
                    }).finally(function () {
                        vm.loading--;
                    })
            }

            init();
        }
    ]);
})();
